export default __webpack_public_path__ + "static/15-5e846742b00eba76f615c7339237251c.webp";